import React from "react";
import { makeStyles } from "@mui/styles";
import { DatePicker } from "@mui/x-date-pickers";
import { TimeService, getMomentTz } from "@dexteel/mesf-core";

const moment = getMomentTz();

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiFormHelperText-filled": {
			display: "none",
		},
	},
	inputEditable: {
		"& .MuiOutlinedInput-root": {
			backgroundColor: "#ffffff",
			"& .MuiOutlinedInput-notchedOutline": {
				border: "1px solid #C4C4C4",
			},
		},
	},
	inputError: {
		"& .MuiOutlinedInput-root": {
			backgroundColor: "#ffffff",
			"& .MuiOutlinedInput-notchedOutline": {
				border: "2px solid #f44336",
			},
		},
	},
}));

interface ComparisonEndFilterProps {
	end: Date;
	start?: Date;
	onEndChange: (date: Date) => void;
	error?: boolean;
}

export const ComparisonEndFilter: React.FC<ComparisonEndFilterProps> = ({
	end,
	start,
	onEndChange,
	error,
}) => {
	const classes = useStyles();

	const handleDateChange = (date: any) => {
		if (date && moment(date).isValid()) {
			onEndChange(moment(date).toDate());
		}
	};

	const today = moment().endOf("day");
	const minDate = start ? moment(start).add(1, "day") : undefined;

	return (
		<div className={classes.root}>
			<DatePicker
				label="End Date"
				timezone={TimeService.getInstance().getServerTimeZone()}
				format="MM/DD/YYYY"
				value={moment(end) as any}
				onChange={handleDateChange}
				maxDate={today as any}
				minDate={minDate as any}
				slotProps={{
					textField: {
						fullWidth: true,
						variant: "outlined",
						className: error ? classes.inputError : classes.inputEditable,
						InputProps: {
							style: {
								height: "38px",
								marginTop: 8,
							},
						},
						InputLabelProps: {
							style: {
								marginTop: "8px",
								fontSize: "14px",
							},
						},
					},
				}}
			/>
		</div>
	);
};
